/**
 * 亲密空间
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message } from 'antd';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import './common.scss';
import { DDLoading } from '../globalPageStatus';
import Util from '../../script/util';

class TokenSort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      intimateRelationId: null,
      list: [],
      draggedItemIndex: null,
    };
  }

  showModal = (detail) => {
    this.setState({
      visible: true,
      intimateRelationId: detail.intimateRelationId,
      list: detail?.keepsakeList || [],
    });
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
    this.props.onReload && this.props.onReload();
  };

  //保存
  onSave = () => {
    const { intimateRelationId, list } = this.state;
    let giftIdList = list.map((item) => item.giftId).join(',');
    let params = {
      intimateRelationId,
      giftIdList,
    };
    HTTP._token_wall_sort(params).then((res) => {
      if (res.code == 200) {
        this.hideModal();
      } else {
        message.error(res.message);
      }
    });
  };

  handleDragStart = (index) => {
    this.setState({ draggedItemIndex: index });
  };

  handleDragOver = (e) => {
    e.preventDefault();
  };

  handleDrop = (index) => {
    const { draggedItemIndex, list } = this.state;
    if (draggedItemIndex !== null) {
      const newList = [...list];
      const [removed] = newList.splice(draggedItemIndex, 1);
      newList.splice(index, 0, removed);
      this.setState({ list: newList, draggedItemIndex: null });
    }
  };

  render() {
    const { loading, list, visible } = this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title={`信物排序`}
          zIndex={1003}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="400px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <Scrollbar
              ref={(el) => (this.scrollElement = el)}
              className="my-scroll-bar"
              style={{ height: '620px', backgroundColor: '#070A1F' }}
            >
              <div
                className="affinity-space-box"
                style={{ padding: '20px 24px 0' }}
              >
                <div className="affinity-space-tip">
                  <p>信物墙排序</p>
                </div>
                <div className="affinity-space-token-wrap">
                  <div className="affinity-space-token-sub">
                    <p>长按拖动可调整信物展示</p>
                  </div>
                  <div className="affinity-space-token-top">
                    {list?.length > 0 ? (
                      <img
                        src={Util.transImgUrl(list[0]?.staticPic, '120x120')}
                        alt=""
                      />
                    ) : null}
                  </div>
                  <div className="affinity-space-token-content">
                    {list?.map((item, index) => (
                      <div
                        className="affinity-space-token-cell"
                        key={item.giftId}
                        draggable
                        onDragStart={() => this.handleDragStart(index)}
                        onDragOver={this.handleDragOver}
                        onDrop={() => this.handleDrop(index)}
                      >
                        <img
                          src={Util.transImgUrl(item.staticPic, '120x120')}
                          alt=""
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className="affinity-space-btn abs yellow"
                  onClick={this.onSave}
                >
                  <span>保存</span>
                </div>
              </div>
            </Scrollbar>
          </DDLoading>
        </Modal>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(TokenSort, { withRef: true })
);
